import { 
  signInWithEmailAndPassword, 
  signOut, 
  User as FirebaseUser,
  onAuthStateChanged,
  sendPasswordResetEmail
} from 'firebase/auth';
import { doc, getDoc, collection, getDocs, query, where } from 'firebase/firestore';
import { auth, db } from '../config/firebase';
import { User, UserType, Driver, Passenger } from '../types';

export class AuthService {
  // Mevcut kullanıcıyı al
  static getCurrentUser(): FirebaseUser | null {
    return auth.currentUser;
  }

  // Giriş yapma
  static async login(email: string, password: string): Promise<User> {
    try {
      console.log('🔐 Giriş işlemi başlıyor:', { email });
      
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const firebaseUser = userCredential.user;
      
      console.log('✅ Firebase Auth giriş başarılı:', firebaseUser.uid);

      // Kullanıcı verilerini Firestore'dan al
      const userData = await this.getUserData(firebaseUser.uid);
      
      if (!userData) {
        throw new Error('Kullanıcı verileri bulunamadı');
      }

      console.log('✅ Kullanıcı verileri alındı:', userData);
      
      return userData;
    } catch (error: any) {
      console.error('❌ Giriş hatası:', error);
      throw new Error(`Giriş başarısız: ${error.message}`);
    }
  }

  // Kullanıcı verilerini al
  static async getUserData(userId: string): Promise<User | null> {
    try {
      console.log('📊 Kullanıcı verileri alınıyor:', userId);
      
      const userDoc = await getDoc(doc(db, 'users', userId));
      
      if (userDoc.exists()) {
        const userData = userDoc.data() as User;
        console.log('✅ Kullanıcı verileri bulundu:', userData);
        return userData;
      } else {
        console.log('❌ Kullanıcı verileri bulunamadı');
        return null;
      }
    } catch (error: any) {
      console.error('❌ Kullanıcı verileri alma hatası:', error);
      return null;
    }
  }

  // Çıkış yapma
  static async logout(): Promise<void> {
    try {
      await signOut(auth);
      console.log('✅ Çıkış başarılı');
    } catch (error: any) {
      console.error('❌ Çıkış hatası:', error);
      throw error;
    }
  }

  // Şifre sıfırlama e-postası gönder
  static async resetPassword(email: string): Promise<void> {
    try {
      console.log('🔄 Şifre sıfırlama e-postası gönderiliyor:', email);
      await sendPasswordResetEmail(auth, email);
      console.log('✅ Şifre sıfırlama e-postası gönderildi');
    } catch (error: any) {
      console.error('❌ Şifre sıfırlama hatası:', error);
      throw new Error(`Şifre sıfırlama başarısız: ${error.message}`);
    }
  }

  // Auth state değişikliği dinleyicisi
  static onAuthStateChange(callback: (user: FirebaseUser | null) => void) {
    return onAuthStateChanged(auth, callback);
  }

  // Tüm kullanıcıları getir
  static async getAllUsers(): Promise<User[]> {
    try {
      console.log('👥 Tüm kullanıcılar getiriliyor...');
      
      const usersSnapshot = await getDocs(collection(db, 'users'));
      const users: User[] = [];
      
      usersSnapshot.forEach((doc) => {
        users.push(doc.data() as User);
      });

      console.log('✅ Kullanıcılar getirildi:', users.length);
      return users;
    } catch (error: any) {
      console.error('❌ Kullanıcıları getirme hatası:', error);
      return [];
    }
  }

  // Şoförleri getir
  static async getDrivers(): Promise<Driver[]> {
    try {
      console.log('🚗 Şoförler getiriliyor...');
      
      const driversQuery = query(
        collection(db, 'users'),
        where('userType', '==', UserType.DRIVER)
      );
      
      const driversSnapshot = await getDocs(driversQuery);
      const drivers: Driver[] = [];
      
      driversSnapshot.forEach((doc) => {
        drivers.push(doc.data() as Driver);
      });

      console.log('✅ Şoförler getirildi:', drivers.length);
      return drivers;
    } catch (error: any) {
      console.error('❌ Şoförleri getirme hatası:', error);
      return [];
    }
  }

  // Yolcuları getir
  static async getPassengers(): Promise<Passenger[]> {
    try {
      console.log('🚶 Yolcular getiriliyor...');
      
      const passengersQuery = query(
        collection(db, 'users'),
        where('userType', '==', UserType.PASSENGER)
      );
      
      const passengersSnapshot = await getDocs(passengersQuery);
      const passengers: Passenger[] = [];
      
      passengersSnapshot.forEach((doc) => {
        passengers.push(doc.data() as Passenger);
      });

      console.log('✅ Yolcular getirildi:', passengers.length);
      return passengers;
    } catch (error: any) {
      console.error('❌ Yolcuları getirme hatası:', error);
      return [];
    }
  }
} 